import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import { FaFacebookF, FaLinkedinIn, FaTiktok, FaWhatsapp } from "react-icons/fa";

import logo from "../../assets/logos/logo-full.png";

const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-top-bar"/>
      <div className="footer-content">
        <div className="footer-logo">
          <img src={logo} alt="Logo de Thorne Global" />
        </div>
        <div className="footer-nav-container">
          <div className="footer-section">
            <h3 className="footer-title"><Link to="/" className="footer-link">Inicio</Link></h3>
            <ul className="footer-submenu">
              <li><Link to="/#third-section" className="footer-link">Introduction</Link></li>
              <li><Link to="/#newsfaq-section" className="footer-link">News</Link></li>
              <li><Link to="/#faq-section" className="footer-link">FAQ's</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h3 className="footer-title"><Link to="/nosotros" className="footer-link">Nosotros</Link></h3>
            <ul className="footer-submenu">
              <li><Link to="/nosotros#us-landing-section" className="footer-link">Thorne Global</Link></li>
              <li><Link to="/nosotros#about-solutions-section" className="footer-link">Soluciones</Link></li>
              <li><Link to="/nosotros#our-ceo-section" className="footer-link">Nuestra CEO</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h3 className="footer-title"><Link to="/servicios" className="footer-link">Servicios</Link></h3>
            <ul className="footer-submenu">
              <li><Link to="/servicios#gestion" className="footer-link">Gestión</Link></li>
              <li><Link to="/servicios#consultoria" className="footer-link">Consultoría</Link></li>
              <li><Link to="/servicios#networking" className="footer-link">Networking</Link></li>
              <li><Link to="/servicios#soporte" className="footer-link">Soporte</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h3 className="footer-title"><Link to="/novedades" className="footer-link">Novedades</Link></h3>
          </div>
        </div>
        <div className="footer-socials">
          <a href="https://www.facebook.com/people/Thorne-Global-Real-Estate/61563832315323/" target="_blank" rel="noopener noreferrer" className="social-link">
            <FaFacebookF />
          </a>
          <a href="https://ae.linkedin.com/in/thorne-global-real-estate-5b51a8296" target="_blank" rel="noopener noreferrer" className="social-link">
            <FaLinkedinIn />
          </a>
          <a href="https://www.tiktok.com/@thorneglobal?_t=ZS-8tcNnMb5yGG&_r=1" target="_blank" rel="noopener noreferrer" className="social-link">
            <FaTiktok />
          </a>
          <a href="https://wa.me/971585582100" target="_blank" rel="noopener noreferrer" className="social-link whatsapp-link">
            <FaWhatsapp />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;